module.exports = __webpack_public_path__ + "img/ufo.99112a4f.png";